module.exports = __webpack_public_path__ + "img/zlfz.9b1520a7.png";